import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnChanges,
} from "@angular/core";
import { HighchartsOptions } from "./highcharts.interface";
import * as Highcharts from "highcharts";

@Component({
  standalone: false,
  selector: "app-highcharts",
  templateUrl: "./highcharts.component.html",
  styleUrls: ["./highcharts.component.scss"],
})
export class HighchartsComponent implements OnInit, OnChanges {
  @Input() options: HighchartsOptions;
  @Input() showValue = false;
  @Input() defaultChart = true;
  @ViewChild("chart") chart: ElementRef;
  constructor() { }

  ngOnInit() {
    //
  }

  ngOnChanges(changes: any) {
  if (changes.options?.currentValue && this.chart) {
      const baseOptions: Highcharts.Options = {
        chart: {
          animation: true
        },
        title: {
          text: '',
          align: 'center',
          floating: true
        },
        yAxis: {
          title: {
            text: undefined
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: this.showValue
            ? '{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>'
            : '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          series: {
            animation: {
              duration: 2000
            }
          }
        }
      };

      Highcharts.chart(
        this.chart.nativeElement,
        {
          ...baseOptions,
          ...this.options
        } as Highcharts.Options
      );
    }
  }
}
